import { takeEvery, put, call } from 'redux-saga/effects';

import { GET_NEW_CLIENTS, GET_SELECTED_NEW_CLIENTS } from './actionTypes';
import { getNewClientsSuccess, getNewClientsFail, getSelectedNewClientsSuccess, getSelectedNewClientsFail, showLoading, hideLoading } from './actions';
import { getNewClients, getSelectedNewClients } from '../../helpers/backend_helper';

function* fetchNewClients() {
  try {
    yield put(showLoading(true))
    const response = yield call(getNewClients)
    yield put(getNewClientsSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getNewClientsFail(error))
  }
}

function* fetchSelectedNewClients({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getSelectedNewClients, id);
    yield put(getSelectedNewClientsSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(false));
    yield put(getSelectedNewClientsFail(error));
  }
}

function* statsSaga() {
  yield takeEvery(GET_NEW_CLIENTS, fetchNewClients)
  yield takeEvery(GET_SELECTED_NEW_CLIENTS, fetchSelectedNewClients)
}

export default statsSaga;
